import 'react';
import styled, { css } from 'styled-components';
import { body } from '@lendi-ui/typography';
import { color, fg, bg } from '@lendi-ui/color';
import { pl, pr } from '@lendi-ui/spacing';
import { normalise } from '@lendi-ui/utils';
import { select } from '@lendi-ui/theme';
import Check from '@lendi-ui/icon/Check';
import InfoTwo from '@lendi-ui/icon/InfoTwo';
import WarnTwo from '@lendi-ui/icon/WarnTwo';
import { jsxs, jsx } from 'react/jsx-runtime';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var Wrapper = styled.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-1am1cv4-0"
})(["", ";display:flex;align-items:center;flex-direction:row;border-radius:12px;width:min-content;", " ", " ", ""], normalise, _ref => {
  var {
    withIcon
  } = _ref;
  return css(["", ";"], !withIcon && pl('xxxs'));
}, pr('xxs'), _ref2 => {
  var {
    variant
  } = _ref2;
  switch (variant) {
    case 'error':
      return css(["border:1px solid ", ";", " ", ";"], color('error.500'), fg('error.500'), bg('error.25'));
    case 'info':
      return css(["border:1px solid ", ";", " ", ";"], color('info.500'), fg('info.500'), bg('info.25'));
    case 'success':
      return css(["border:1px solid ", ";", " ", ";"], color('success.500'), fg('success.500'), bg('success.25'));
    case 'warn':
      return css(["border:1px solid ", ";", " ", ";"], color('warn.500'), fg('warn.500'), bg('warn.25'));
    default:
      return undefined;
  }
});
/**
 * Domain font `larsseit` does not center aligned by default, so doing a margin-bottom to
 * some value to accomodate the alignment issue wrt icon. - HUB-295
 */

var contentSizeMixin = option => {
  var {
    size
  } = option;
  switch (size) {
    case 'sm':
      return css(["", ";margin-bottom:", ";"], body({
        size: 'xs'
      }), _ref3 => {
        var {
          theme
        } = _ref3;
        return select('logo.logoName')({
          theme
        }) === 'DomainLogo' ? '-3px' : 0;
      });
    case 'lg':
      return css(["", ";margin-bottom:", ";"], body({
        size: 'lg'
      }), _ref4 => {
        var {
          theme
        } = _ref4;
        return select('logo.logoName')({
          theme
        }) === 'DomainLogo' ? '-5px' : 0;
      });
  }
};
var IconWrapper = styled.span.withConfig({
  displayName: "indexstyle__IconWrapper",
  componentId: "lui__sc-1am1cv4-1"
})(["line-height:0;"]);
var ContentWrapper = styled.span.withConfig({
  displayName: "indexstyle__ContentWrapper",
  componentId: "lui__sc-1am1cv4-2"
})(["", ";"], contentSizeMixin);
var _excluded = ["variant", "hasIcon", "statusText", "size"];
var StatusBadge = _ref => {
  var {
      variant,
      hasIcon = false,
      statusText,
      size = 'sm'
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var badgeIcon;
  var withIcon = !!hasIcon;
  var iconHeight = size === 'lg' ? '1.5em' : '1em';
  switch (variant) {
    case 'error':
      badgeIcon = /*#__PURE__*/jsx(WarnTwo, {
        color: "error.500",
        height: iconHeight
      });
      break;
    case 'info':
      badgeIcon = /*#__PURE__*/jsx(InfoTwo, {
        color: "info.500",
        height: iconHeight
      });
      break;
    case 'success':
      badgeIcon = /*#__PURE__*/jsx(Check, {
        color: "success.500",
        height: iconHeight
      });
      break;
    case 'warn':
      badgeIcon = /*#__PURE__*/jsx(WarnTwo, {
        color: "warn.500",
        height: iconHeight
      });
      break;
  }
  return /*#__PURE__*/jsxs(Wrapper, _objectSpread2(_objectSpread2({
    variant: variant,
    withIcon: withIcon
  }, otherProps), {}, {
    children: [withIcon && /*#__PURE__*/jsx(IconWrapper, {
      children: badgeIcon
    }), /*#__PURE__*/jsx(ContentWrapper, {
      size: size,
      children: statusText
    })]
  }));
};
export { StatusBadge as default };